// removed by extract-text-webpack-plugin
module.exports = {"header":"Packlists__header___3dbJv","customer":"Packlists__customer___1P4-N","date":"Packlists__date___3OJk4","route":"Packlists__route___kDPPz","caption":"Packlists__caption___JTlON","table":"Packlists__table___22zhK","left":"Packlists__left___2-qDE","center":"Packlists__center___d16Kn","nowrap":"Packlists__nowrap___26PmU","packlist":"Packlists__packlist___1DEBm","packlists":"Packlists__packlists___1uvuf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Reports/Packlists/Packlists.scss
// module id = 1248
// module chunks = 1